import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";
import Login from "@/views/Login/index.vue";

import Welcome from "@/views/Welcome/index.vue";
import Landing from "@/views/Landing/index.vue";

import Root from "@/views/Root.vue";

import Dashboard from "@/views/Operations/Dashboard.vue";
import Invoices from "@/views/Operations/Invoices.vue";
import Forwards from "@/views/Operations/Forwards.vue";
import Balance from "@/views/Operations/Conversions.vue";

import Conversions from "@/views/History/Conversions.vue";
import Payments from "@/views/History/Payments.vue";

import Statement from "@/views/Wallets/AccountStatement.vue";
import Suppliers from "@/views/Wallets/Suppliers.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    component: () => import("@/views/Landing/index.vue"),
  },
  {
    path: "/home",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "Root",
    component: Root,
    redirect: {
      name: "Dashboard",
    },
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/invoices",
        name: "Invoices",
        component: Invoices,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/forwards",
        name: "Forwards",
        component: Forwards,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/balance",
        name: "Balance",
        component: Balance,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/conversions",
        name: "Conversions",
        component: Conversions,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payments",
        name: "Payments",
        component: Payments,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/suppliers",
        name: "Suppliers",
        component: Suppliers,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/statement",
        name: "Statement",
        component: Statement,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/welcome",
        name: "Welcome",
        component: Welcome,
        meta: {
          requiresAuth: true,
        },
      },
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  // When opening a new route send the user to the default location (top left)
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (Store.state.sToken) {
      if (to.name === "Login") {
        next({ name: "Root" }); // Renderiza el componente "Home"
      }
      next();
    } else {
      next({
        path: "/login",
      });
    }
  } else {
    if (Store.state.sToken) {
      if (to.name === "Login") {
        next({ name: "Root" }); // Renderiza el componente "Home"
      }
      next();
    } else {
      next();
    }
  }
});

export default router;
